import { QuoteShareMetadata } from '../types';

export const QuoteShareQueryKey = {
  GET_METADATA: 'quote_share_get_metadata'
} as const;

export const getQuoteShareMetadataQuery = (
  apiBaseUrl: string,
  companyId: string,
  token: string,
  preview = false
) => ({
  queryKey: [QuoteShareQueryKey.GET_METADATA, companyId, token, preview],
  queryFn: async (): Promise<QuoteShareMetadata> => {
    const url = `${apiBaseUrl}/public/quote-shares/${companyId}/${token}${
      preview ? '?preview=true' : ''
    }`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`status_${res.status}`);
    return res.json();
  },
  retry: false,
  refetchOnWindowFocus: false,
  staleTime: Infinity
});
